// @ts-nocheck
import React from 'react';
import { isEmpty } from 'lodash';
import cx from 'classnames';
import css from './css';
import { SearchIcon } from '../icons';

interface Props {
  type: string;
  value?: string;
  onValueChange(value: string): void;
  delay: number;
  searchIcon?: boolean;
  className?: string;
  autoFocus?: boolean;
  pattern?: RegExp;
  isNumber?: boolean;
  focus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  containerStyle?: string;
  placeholder: string;
}

interface State {
  value: string;
  rawValue: string;
}

export default class DelayedTextInput extends React.Component<Props, State> {
  static defaultProps = {
    type: 'text',
    delay: 300,
  };

  static styles: object;

  _input: HTMLInputElement;

  _inputDelay: any;

  state = {
    value: this.props.value || '',
    rawValue: this.props.value || '',
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    if (props.value !== state.value) {
      return {
        rawValue: props.value,
        value: props.value,
      };
    }

    return null;
  }

  render() {
    return (
      <div className={cx(styles.inputContainer, this.props.containerStyle)}>
        <input
          autoFocus={this.props.autoFocus}
          type={this.props.type}
          className={cx(this.props.className, styles.default)}
          value={this.state.rawValue}
          onFocus={this.props.focus}
          placeholder={this.props.placeholder}
          onChange={this.handleValueChange}
          ref={this.bindInput}
        />
        {this.props.searchIcon && (
          <span className={styles.icon}>
            <SearchIcon key="0" color="#b5b5b5" width="20" />
          </span>
        )}
      </div>
    );
  }

  handleValueChange = (event) => {
    if (this.props.pattern && !this.props.pattern.test(event.target.value)) {
      event.preventDefault();
      return;
    }

    if (this.props.isNumber && isEmpty(event.target.value)) {
      event.target.value = 0;
    }

    this.setState({ rawValue: event.target.value });

    const delayedValue = event.target.value;

    clearTimeout(this._inputDelay);

    this._inputDelay = setTimeout(() => {
      this._inputDelay = null;

      this.props.onValueChange(delayedValue);
    }, this.props.delay);
  };

  bindInput = (node) => {
    this._input = node;
  };
}

const styles = css({
  inputContainer: {
    position: 'relative',
  },

  icon: {
    position: 'absolute',
    right: 3,
    top: '.25em',
  },

  default: {
    width: '100%',
    border: '1px solid #ccc',
    padding: '6px 6px',
    borderRadius: 4,
    boxSizing: 'border-box',
    overflow: 'hidden',
    outline: 'none',
    fontSize: 13,
    color: '#333',

    ':focus': {
      borderColor: 'rgba(82, 168, 236, 0.8)',
      transition: 'border linear 0.2s, box-shadow linear 0.2s',
      boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(82, 168, 236, 0.6)',
    },
  },
});

DelayedTextInput.styles = DelayedTextInput;
